import { useCallback } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import {
    canRedoSelector,
    canUndoSelector,
    currentDiagramStateSelector,
    diagramHistoryAtom,
    DiagramSnapshot,
    isDiagramDirtySelector,
    markAsSavedState,
    pushHistoryState,
    redoHistoryState,
    resetHistoryState,
    undoHistoryState,
} from "../atoms/diagramHistoryAtom";

export const useDiagramHistory = () => {
    const [historyState, setHistoryState] = useRecoilState(diagramHistoryAtom);
    const isDirty = useRecoilValue(isDiagramDirtySelector);
    const canUndo = useRecoilValue(canUndoSelector);
    const canRedo = useRecoilValue(canRedoSelector);
    const currentState = useRecoilValue(currentDiagramStateSelector);

    const pushState = useCallback(
        (snapshot: DiagramSnapshot) => {
            setHistoryState((current) => pushHistoryState(current, snapshot));
        },
        [setHistoryState]
    );

    const undo = useCallback(() => {
        setHistoryState((current) => undoHistoryState(current));
    }, [setHistoryState]);

    const redo = useCallback(() => {
        setHistoryState((current) => redoHistoryState(current));
    }, [setHistoryState]);

    const markAsSaved = useCallback(() => {
        setHistoryState((current) => markAsSavedState(current));
    }, [setHistoryState]);

    const reset = useCallback(() => {
        setHistoryState(resetHistoryState());
    }, [setHistoryState]);

    return {
        // State
        isDirty,
        canUndo,
        canRedo,
        currentState,
        historyLength: historyState.history.length,
        currentIndex: historyState.currentIndex,

        // Actions
        pushState,
        undo,
        redo,
        markAsSaved,
        reset,
    };
};
